export default __webpack_public_path__ + "static/media/sk.254c1186.jpeg";